import ReactDOM from 'react-dom';
import { forEach } from 'lodash';

/**
 * Remove dom element
 * @param {string} domElement
 * */
export const removeDomElement = (domElement) => {
  const toolbarQuery = document.querySelector(domElement);
  if (toolbarQuery) {
    return toolbarQuery.parentElement.removeChild(toolbarQuery);
  }
};

/**
 * Remove dom elements
 * @param {string} domElement
 * */
export const removeDomElements = (domElement, container = document) => {
  forEach(container.querySelectorAll(domElement), (element) => {
    element.parentElement.removeChild(element);
  });
};

/**
 * Render buttons over selected dom element
 * @param {string} elementContainer Element content that will be overwritten
 * @param {func} render The function that is bringing the content
 * */
export const renderButtons = (elementContainer, render) => {
  const content = render();
  forEach(document.querySelectorAll(elementContainer), (element) => {
    ReactDOM.render(content, element);
  });
};
